import { Box, Button, Card, Container, TextField } from "@mui/material";
import { Typography, Autocomplete } from "@mui/material";
import React, { useEffect } from "react";
import HttpService from "../../../../hooks/Https-services";
import { APIRoutes } from "../../../../utils/constants";
import { useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
const GameView = () => {
  const [gameData, setGameData] = React.useState({} as any);
  const [rules, setRules] = React.useState([] as any);
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = React.useState<any>("");
  const [debouncedSearchValue, setDebouncedSearchValue] = React.useState("");
  const [selectedRule, setSelectedRule] = React.useState<any>(null);
  const GetGameDetails = React.useCallback(async () => {
    try {
      const res = await HttpService.getapi(APIRoutes.GameDetails + "/" + id);
      setGameData(res?.data?.data[0]);
    } catch (error) {}
  }, [id]);
  React.useEffect(() => {
    GetGameDetails();
  }, [GetGameDetails]);

  // Update selected rule when gameData or rules change
  React.useEffect(() => {
    if (gameData?.rule_id && rules.length > 0) {
      const currentRule = rules.find(
        (item: any) => item.ID === gameData.rule_id
      );
      setSelectedRule(currentRule || null);
    }
  }, [gameData, rules]);
  const GetRules = React.useCallback(async () => {
    try {
      const query: any = {
        status: true,
        page: 1,
        limit: 100,
      };
      if (debouncedSearchValue) {
        query.search = debouncedSearchValue;
      }
      const res = await HttpService.get(
        APIRoutes.GetRuleList + "?" + new URLSearchParams(query).toString()
      );
      setRules(res?.data?.data?.rules);
    } catch (error) {}
  }, [debouncedSearchValue]);

  // Using setTimeout for debouncing search value
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 500);
    return () => clearTimeout(timer);
  }, [searchValue]);

  useEffect(() => {
    GetRules();
  }, [debouncedSearchValue, GetRules]);
  const handleChangeRuleID = async (ruleID: number | null) => {
    try {
      const res = await HttpService.put(
        APIRoutes.UpdateRuleAdmin.replace(":game_id", id?.toString() || ""),
        { rule_id: ruleID }
      );
      toast.success("Rule updated successfully");
      GetGameDetails();
    } catch (error: any) {
      toast.error(error?.response?.data?.message);
    }
  };

  return (
    <Container style={{ padding: "20px", marginTop: "20px" }} maxWidth="lg">
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <Box>
          <Button
            startIcon={<ArrowBackIcon />}
            variant="contained"
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </Box>
        <Typography sx={{ fontWeight: "600" }} variant="h5">
          Game Setting
        </Typography>
        <Card sx={{ display: "flex", gap: "20px", mt: 2, p: 2 }}>
          <Box>
            <Typography sx={{ fontWeight: "600" }} variant="h6">
              Game Details
            </Typography>
            <Box>
              <Typography sx={{ fontWeight: "400" }} variant="body1">
                Away Team: {gameData?.away_team}
              </Typography>
              <Typography sx={{ fontWeight: "400" }} variant="body1">
                Home Team: {gameData?.home_team}
              </Typography>
              <Typography sx={{ fontWeight: "400" }} variant="body1">
                Date: {gameData?.game_date_time}
              </Typography>
            </Box>
          </Box>
        </Card>
        <Card sx={{ display: "flex", gap: "20px", mt: 2, p: 2 }}>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              gap: "20px",
              justifyContent: "space-between",
            }}
          >
            <Typography sx={{ fontWeight: "600" }} variant="h6">
              Adjust Geoblocking
            </Typography>
            <Box sx={{ width: "400px" }}>
              <Autocomplete
                fullWidth
                freeSolo
                options={rules || []}
                onChange={(event, value) => {
                  if (value) {
                    setSelectedRule(value);
                    handleChangeRuleID(value?.ID);
                  } else {
                    setSelectedRule(null);
                    handleChangeRuleID(null);
                  }
                }}
                value={selectedRule}
                getOptionLabel={(option) =>
                  option?.Title ? `${option?.Title}(${option?.Type})` : ""
                }
                isOptionEqualToValue={(option, value) =>
                  option?.ID === value?.ID
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    onChange={(e) => {
                      setSearchValue(e.target.value);
                    }}
                    label="Select Option"
                    variant="outlined"
                  />
                )}
                loading={rules.length === 0}
                loadingText="Loading rules..."
              />
            </Box>
          </Box>
        </Card>
      </Box>
    </Container>
  );
};
export default GameView;
